/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Table, Row, Col, Upload, Modal, Checkbox } from "antd";
import { MAIL_TEMPLATE_LIST_TRAINEE, PATH, eContentFields } from "../../constant";
import { StyledButton } from "../../../../../../components/styled-antd";
import { AddRowModal } from "./Modal";
import { EditRowModal } from "./Modal";
import { getInforRegistrationCourse, isHideEdit } from "../../utils";
import { useSelector } from "../../../../../../store/store";
import { HOSummaryEmployeeRequestService } from "../../../../../../services/human-organization/summary-employee-request.service";
import { requestStatus } from "../../../../../../constants";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { approveRequestEmail } from "../../utils/send-mail";
import { useState } from "react";
import type { UploadProps } from "antd/es/upload/interface";
import ExcelJS from "exceljs";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import { HiOutlineTrash } from "react-icons/hi2";
import _ from "lodash";

export function EditableTable({ eRequests, setERequests, form, detail }: any) {
  const history = useHistory();
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const [fileList, setFileList] = useState<any[]>([]);

  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();

  const columns = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, eRequests.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: any, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter((value): any => value != index);
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="d-flex">
            <EditRowModal dataSource={eRequests} setDataSource={setERequests} index={index} />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(eRequests.length / pageSize);
                if ((eRequests.length - 1) % 10 == 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
                }

                setERequests((prev: any) => {
                  return prev.filter((value: any, indexValue: number) => indexValue != index);
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash size={20} className="cursor-pointer" color="#dc2626" />
            </Button>
          </div>
        );
      },
      isHide: isHideEdit(
        getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status,
        getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).isApprover,
      ),
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: any, index: number) => <>{(currentPage - 1) * pageSize + index + 1}</>,
    },
    ...eContentFields.map((value, index) => {
      return {
        title: value.label,
        dataIndex: value.field,
        key: value.field,
      };
    }),
  ].filter((value: any) => value.isHide != true);

  const { id } = useRouteMatch().params as any;
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);

  const approveRequest = async () => {
    const action =
      getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status ===
      requestStatus.submitted
        ? "Đồng ý"
        : "Tạo";

    let initFields = {
      eSubRequestsStatus: detail.fields?.eSubRequestsStatus
        ? JSON.stringify({
            ...JSON.parse(detail.fields?.eSubRequestsStatus),
            [form.getFieldValue("eDepartment")]: {
              status: requestStatus.completed,
              approver: form.getFieldValue("eApprovedBy"),
            },
          })
        : JSON.stringify({
            [form.getFieldValue("eDepartment")]: {
              status: requestStatus.completed,
              approver: form.getFieldValue("eApprovedBy"),
            },
          }),
    };

    try {
      await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(id, initFields);

      await approveRequestEmail(
        detail,
        MAIL_TEMPLATE_LIST_TRAINEE.FINISH,
        "",
        mailtemplates,
        form.getFieldValue("eDepartment"),
      );

      CreateNotification({
        title: "Thành công",
        body: `${action} danh sách học viên thành công`,
        icon: "/icons/success.png",
      });

      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `${action} danh sách học viên thất bại`,
        icon: "/icons/error.png",
      });

      history.push(PATH.HOME);
    }
  };

  const rejectRequest = async () => {
    let initFields = {
      eSubRequestsStatus: detail.fields?.eSubRequestsStatus
        ? JSON.stringify({
            ...JSON.parse(detail.fields?.eSubRequestsStatus),
            [form.getFieldValue("eDepartment")]: {
              status: requestStatus.rejected,
              approver: form.getFieldValue("eApprovedBy"),
            },
          })
        : JSON.stringify({
            [form.getFieldValue("eDepartment")]: {
              status: requestStatus.rejected,
              approver: form.getFieldValue("eApprovedBy"),
            },
          }),
    };

    try {
      await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(id, initFields);

      await approveRequestEmail(
        detail,
        MAIL_TEMPLATE_LIST_TRAINEE.REJECT,
        "",
        mailtemplates,
        form.getFieldValue("eDepartment"),
      );

      CreateNotification({
        title: "Thành công",
        body: `Từ chối danh sách học viên thành công`,
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối danh sách học viên thất bại`,
        icon: "/icons/error.png",
      });

      history.push(PATH.HOME);
    }
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  const { exportFile } = useExcelTemplate();

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(eRequests.length / pageSize);
    if ((eRequests.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...eRequests];
    newDataSource = newDataSource.filter((value, index) => !listDelete.includes(index));
    setERequests(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      if (file.name.split(".")[file.name.split(".").length - 1] != "xlsx") {
        CreateNotification({
          title: "Import file thất bại",
          body: `File sai định dạng`,
          icon: "/icons/error.png",
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        // let wrongDepartment = false

        // for (const item of data) {
        //   eContentFields.forEach((value, index) => {
        //   if(value.field === "unit" &&  item[index] != form.getFieldValue("eDepartment")){
        //       wrongDepartment = true;
        //       console.log({
        //         test: value.field,
        //         test1: form.getFieldValue("eDepartment"),
        //       });
        //     }
        //   });
        // }

        //         if (wrongDepartment) {
        //           CreateNotification({
        //             title: "Import file thất bại",
        //             body: `Vui lòng nhập đơn vị là ${form.getFieldValue(
        //               "eDepartment"
        //             )}`,
        //             icon: "/icons/error.png",
        //           });
        // alert(1)
        //           return;
        //         }

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        let isValid = true;
        const re = new RegExp(/^[0-9]+$/);
        const re2 = new RegExp(/^\s*-?[0-9]{1,10}\s*$/);
        let message = "";

        for (const item of data) {
          // eslint-disable-next-line no-loop-func
          eContentFields.forEach((value, index) => {
            if (value.field === "numLessons" || value.field === "phoneNumber") {
              if (!re.test(item[index])) {
                isValid = false;
                message = "Điện thoại hoặc số tiết phải là con số";
              }
            }
            if (value.field === "phoneNumber") {
              if (!re2.test(item[index])) {
                isValid = false;
                message = "Số điện thoại tối đa 10 chữ số";
              }
            }
          });
        }

        if (!isValid) {
          CreateNotification({
            title: "Import file thất bại",
            body: message,
            icon: "/icons/error.png",
          });

          return;
        }

        for (const item of data) {
          const record: any = {};
          eContentFields.forEach((value, index) => {
            if (value.field === "email") {
              record[value.field] = item[index]?.text || item[index];
            } else if (value.field === "unit") {
              record[value.field] = form.getFieldValue("eDepartment");
            } else {
              record[value.field] = item[index];
            }
          });

          dataSource.push(record);
        }

        setERequests((prev: any) => [...prev, ...dataSource]);

        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
    accept: ".xlsx",
  };

  const downLoad = async () => {
    const template = {
      fields: eContentFields.map((value) => value.field),
      sheet: "sheet1",
      fileName: "Bảng nhân sự đăng ký khóa học",
      structures: eContentFields.map((value) => {
        return {
          header: value.label,
          validate: (cell: any) => {
            return true;
          },
        };
      }),
    };

    await exportFile(template);
  };

  return (
    <div>
      <Row>
        {!getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).isApprover &&
          getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status !=
            requestStatus.completed &&
          getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status !=
            requestStatus.rejected && (
            <Col>
              <AddRowModal dataSource={eRequests} setDataSource={setERequests} form={form} />
            </Col>
          )}
        {!isHideEdit(getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status) &&
          !getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).isApprover && (
            <>
              <Col>
                {!isMultiDelete && (
                  <Button className="ml-3" type="primary" danger onClick={() => setIsMultiDelete(true)}>
                    Chọn nhiều để xóa
                  </Button>
                )}

                {isMultiDelete && (
                  <StyledButton
                    className="ml-3"
                    bgColor="green"
                    onClick={() => {
                      setIsMultiDelete(false);
                      setListDelete([]);
                    }}
                  >
                    Quay lại
                  </StyledButton>
                )}

                {listDelete.length != 0 && (
                  <Button className="ml-3" type="primary" onClick={showDeleteConfirm} danger>
                    Xóa dữ liệu đã chọn
                  </Button>
                )}
              </Col>

              <Col>
                <Upload {...props}>
                  <StyledButton bgColor="blue" className="mx-3">
                    Tải biểu mẫu{" "}
                  </StyledButton>
                </Upload>
              </Col>

              <Col>
                <div className="mt-1">
                  <a href="#" className="text-primary" onClick={downLoad}>
                    Download biểu mẫu tại đây
                  </a>
                </div>
              </Col>
            </>
          )}
      </Row>

      <Table
        columns={columns}
        dataSource={eRequests}
        pagination={{
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
        }}
      />

      {![requestStatus.completed, requestStatus.rejected].includes(
        getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status,
      ) && (
        <div className="d-flex justify-content-center">
          {!getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).isApprover && (
            <StyledButton bgColor="orange" type="primary" htmlType="submit" className="ml-3">
              {getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).status ==
              requestStatus.submitted
                ? "Cập nhật"
                : "Gửi yêu cầu"}
            </StyledButton>
          )}

          {getInforRegistrationCourse(detail, currentUserName, form.getFieldValue("eDepartment")).isApprover && (
            <>
              <StyledButton bgColor="red" danger type="primary" className="ml-3" onClick={rejectRequest}>
                Không đồng ý
              </StyledButton>

              <StyledButton bgColor="green" type="primary" className="ml-3" onClick={approveRequest}>
                Đồng ý
              </StyledButton>
            </>
          )}
        </div>
      )}
    </div>
  );
}
